"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M9.4998 1c-1.3807 0-2.5 1.1193-2.5 2.5v6.3244l-.0497-.071c-.7411-1.1502-2.272-1.4919-3.4328-.7612-1.158.7288-1.5132 2.251-.8038 3.4158 1.055 1.7284 2.054 3.4954 3.0372 5.2651C6.662 19.3135 7.0814 20.2556 7.469 22h2.045c-.4609-2.2355-.9474-3.3768-2.0149-5.2981-1.4243-2.5637-2.9114-5.0572-3.0506-5.2903-.1458-.2441-.1262-.5629.1342-.7268.2466-.1552.5527-.0605.7024.1773l1.8123 2.5922L9 12.7547 8.9998 3.5a.5.5 0 0 1 1 0v8h2V7.2873l1 .4118V11.5h2V8.5226l1 .4117V11.5h2V9.7579l.3808.1568a.9994.9994 0 0 1 .6193.9242v3.7861c0 1.4571-.4389 2.7541-.9264 3.953-.2311.5684-.5055 1.1895-.6992 1.714-.1959.5303-.3744 1.1226-.3744 1.708h2c0-.2146.0714-.5301.2505-1.015.2063-.5585.4516-1.1022.6758-1.6537.5125-1.2604 1.0737-2.8509 1.0737-4.7063v-3.7861a2.9993 2.9993 0 0 0-1.8578-2.7736l-7.1423-2.9409V3.5c0-1.3807-1.1193-2.5-2.5-2.5z"
  })];
};

exports.default = _default;